module.exports = __webpack_public_path__ + "img/trade_n-social.8cc0b1a5.png";